// src/pages/premium/Subjects.jsx
import React from "react";

export default function Subjects() {
  return (
    <div className="container mt-5 text-center">
      <h2>📖 UPSC Subjects</h2>
      <p>All subject materials here.</p>
    </div>
  );
}